<template>
    <div
        :data-component-name="$options.name"
        :class="wrapperClasses"
        v-if="!disabledIDs.includes(field.id)"
    >
        <inputlabel :field="field" />
        
        <div class="o-form__item"
            :class="{'o-checkbox__group': true}"
        >
            <div
                :class="{
                    'o-checkbox__wrap': true,
                    'o-checkbox__wrap': true
                }"
                v-for="(choice, ci) in field.inputChoices"
                :key="'cb-'+ci+'-'+field.id"
                style="display: block;"
            >
                <input
                    v-model="field.value"
                    :class="{ 
                        'o-checkbox': true,
                        'o-checkbox': true,
                        'readonly': field.inputReadonly === true,
                        'required': requiredField === true
                    }"
                    v-on="readOnlyHandlers"
                    type="checkbox"
                    :id="'input-' +ci+'-'+field.id"
                    :name="(field.inputChoices.length>1) ? field.inputName+'[]' : field.inputName"
                    :placeholder="field.inputPlaceholder"
                    :value="(String(choice.value).trim() != '') ? choice.value : choice.text"
                    :required="(field.inputRequired === true && field.value!==null && field.value.length == 0) ? 'required' : false"
                    :checked="(field.value?.includes(choice.value)) ? 'checked' : false"
                >
                <label 
                    :class="{
                        'o-checkbox-label': true,
                        'o-checkbox-label': true
                    }"
                    :for="'input-' + ci + '-' + field.id" 
                >
                    <!-- Inline SVG if available in svgContentMap -->
                    <span v-if="choice.picto && svgContentMap[choice.picto]" v-html="svgContentMap[choice.picto]"></span>
                    <span v-html="(String(choice.text).trim() != '') ? choice.text : choice.value"></span>
                </label>
                <div class="o-form__validation">
                    <span class="o-form__validation__required" v-if="field.inputChoices.length<2">
                        {{ _t('Ce champ est obligatoire.') }}
                    </span>
                    <span class="o-form__validation__required" v-else>
                        {{ _t('Vous devez choisir au moins un élément.') }}
                    </span>
                    <span class="o-form__validation__error">
                        {{ _t('Ce champ est invalide.') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'Input-checkbox',
    props: {
        field: {
            type: Object,
            default() {
                return {}
            },
        },
        disabledIDs: {
            type: Array,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            selected: [],
            requiredField: false,
            svgContentMap: {}, // Store SVG markup by URL
            readOnlyHandlers: {
                keydown: this.handleEvent,
                paste: this.handleEvent,
                focus: this.handleEvent,
                mousedown: this.handleEvent,
            }
        };
    },
    mounted() {
        this.requiredField = this.field.inputRequired;
        if (this.field.value === null) {
            this.field.value = [];
        }
        if (this.field.value !== null && !Array.isArray(this.field.value)) {
            this.field.value = [this.field.value];
        } else {
            this.selected = this.field.value;
        }

        if (!this.field.value.length && this.field.inputChoices.length) {
            let defaultValue = this.field.inputChoices.find(choice => choice.default);
            if (defaultValue) {
                this.selected = [defaultValue.value];
            }
        }

        // Fetch SVG contents for each choice's `picto` URL if available
        this.field.inputChoices.forEach((choice) => {
            if (choice.picto && !this.svgContentMap[choice.picto]) {
                this.fetchSVGContent(choice.picto);
            }
        });
    },
    watch: {
        selected: function () {
            this.field.value = this.selected;
        }
    },
    computed: {
        wrapperClasses() {
            let classes = '';

            if (!this.field.inputClass) {
                classes += 'o-grid-12 ';
            } else {
                classes += this.field.inputClass + ' ';
            }

            if (this.field.inputChoicesButtonStyle === true) {
                classes += 'o-styled-input ';
            }

            if (this.field.inputType === 'inlinecheckbox') {
                classes += 'o-inline-input ';
            }

            return classes;
        },
    },
    methods: {
        handleEvent(e) {
            if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
        },
        async fetchSVGContent(url) {
            try {
                const response = await axios.get(url, { responseType: 'text' });
                this.svgContentMap[url] = response.data;
            } catch (error) {
                console.error(`Failed to load SVG from ${url}:`, error);
            }
        }
    }
};
</script>
